import PropTypes from "prop-types";
import React from "react";
import {AiOutlineRight} from "react-icons/all";
import {Col, Row} from "react-bootstrap";
import {isMobile, isMobileOnly} from "react-device-detect";
import ReactGA from "react-ga4";

const HeroSliderNineSingle = ({ data, sliderClass, marginTop, isSide, banner }) => {

  const onRedirect = (data) => {
    ReactGA.event({
      category: 'Banner',
      action: 'Redirect to ' + data.title
    });
    ReactGA.event({
        category: 'Banner',
        action: 'Redirect to ' + data.title + " for url : " + data.url
    });
    data.url.includes('https://app.therunningcollective.fr') ? window.location = extractUrl(data.url) : window.open(data.url, '_blank')
  } 

  return (
      <div
          className={`single-slider-2 slider-height-1 d-flex align-items-center slider-height-res bg-img ${
              sliderClass ? sliderClass : ""
          }`}
          onClick={() => {onRedirect(data)}}
          style={{
            cursor: "pointer",
            height: isSide ? "100%" : "",
            width: "100%",
            paddingBottom: marginTop && marginTop !== "" ? "20px": "",
            backgroundSize: (isMobileOnly || !banner) ? "" : "100%",
            backgroundPosition: (isMobileOnly || !banner) ? "center" : "top",
            backgroundImage: `linear-gradient(rgba(0, 0, 0, ${data.contrast != "" ? data.contrast : "0.3"}),rgba(0, 0, 0, ${data.contrast != "" ? data.contrast : "0.3"})) , url(${(isMobileOnly ? data.image : data.desktopImage != "" ? data.desktopImage : data.image)})`
          }}
      >
        <div className="container" style={{marginTop: marginTop && marginTop != "" ? marginTop : isMobileOnly ? "140px" : "-150px"}}>
          <div className="row">
            <div className={isSide ? "col-xl-11 col-lg-11 col-md-7 ml-auto" : "col-xl-6 col-lg-6 col-md-7 ml-auto"}>
              <div className="slider-content-2 slider-animated-1" style={{
                paddingLeft: isMobileOnly ? " 15px" : "none",
                paddingRight: isMobileOnly ? " 15px" : "none",

              }}>
                {
                  data.title != "" ?
                    <>
                       <div className="slider-h3 animated" style={{color: data.textColor ? rgbToHex(data.textColor.r, data.textColor.g, data.textColor.b) : 'black', 
                        lineHeight: isMobileOnly ? "30px" : "50px"}}>
                        <span className={"trait"} style={{backgroundColor: data.textColor ? rgbToHex(data.textColor.r, data.textColor.g, data.textColor.b) : 'black', 
                          lineHeight: isMobileOnly ? "30px" : "50px"}}/>
                        {data.title}
                      </div>
                    </>
                  : null
                }

                {
                  data.title !== "" && data.subtitle !== "" ?
                  <hr style={{
                    backgroundColor: data.textColor ? rgbToHex(data.textColor.r, data.textColor.g, data.textColor.b) : 'black',
                    marginTop: "10px", marginBottom: "10px"}}/>
                    : null
                }
               
                <Row>
                  <Col xs={ isSide ? 8 : 10} style={{paddingBottom: "15px"}}>
                  <span
                      className="slider-h1 animated"
                      style={{color: data.textColor ? rgbToHex(data.textColor.r, data.textColor.g, data.textColor.b) : 'black'}}
                      dangerouslySetInnerHTML={{ __html: data.subtitle }}
                  ></span>
                  </Col>
                  {
                    data.title == "" && data.subtitle == "" ?
                    null
                    : 
                    <Col xs={isSide ? 4 : 2}>
                    <div className="slider-btn btn-hover" style={{textAlign: isSide ? "center" : "right"}}>
                      <a
                          className="animated">
                        <AiOutlineRight size="1rem"/>
                      </a>
                    </div>
                  </Col>
                  }
                  
                </Row>
              </div>
            </div>
          </div>
        </div>
        {
          data && data.id == "4f9c503b-ce2e-43db-ba0b-b5df1d1c46e3"
        ?
        <iframe src="https://ad.doubleclick.net/ddm/trackimpi/N6311.5617844THERUNNINGCOLLECTI/B33689589.422295075;dc_trk_aid=614776510;dc_trk_cid=236244471;ord=[timestamp];dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;tfua=;gdpr=${GDPR};gdpr_consent=${GDPR_CONSENT_755};ltd=;dc_tdv=1?" WIDTH={1} HEIGHT={1} MARGINWIDTH={0} MARGINHEIGHT={0} HSPACE={0} VSPACE={0} FRAMEBORDER={0} SCROLLING={"no"} BORDERCOLOR={'#000000'}></iframe>
        : null }
      </div>
  );
};

function extractUrl(url){
  const newURL = url.replace('https://app.therunningcollective.fr', process.env.PUBLIC_URL);
  return newURL
}

function rgbToHex(r, g, b) {
  return "#" + ((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1);
}

HeroSliderNineSingle.propTypes = {
  data: PropTypes.object,
  sliderClass: PropTypes.string,
  banner: PropTypes.any
};

export default HeroSliderNineSingle;
